<div id="wrapper">
  <section class="top-grid">
    <mat-card class="panel process-panel">
      <h2>Incoming Data</h2>
      <p class="panel-subtitle">Transfer Processes</p>

      <div *ngIf="incomingTotal > 0; else noIncomingData" class="chart-content">
        <div class="chart-wrapper">
          <canvas id="incomingDonutChart" aria-label="Incoming transfer processes chart"></canvas>
        </div>

        <div class="legend">
          <span class="legend-item"><span class="dot completed"></span>Completed</span>
          <span class="legend-item"><span class="dot progress"></span>In Progress</span>
          <span class="legend-item"><span class="dot error"></span>Error</span>
        </div>

        <p class="total">Total: {{ incomingTotal }}</p>
      </div>

      <ng-template #noIncomingData>
        <div class="no-data-placeholder">No data</div>
      </ng-template>
    </mat-card>

    <mat-card class="panel process-panel">
      <h2>Outgoing Data</h2>
      <p class="panel-subtitle">Transfer Processes</p>

      <div *ngIf="outgoingTotal > 0; else noOutgoingData" class="chart-content">
        <div class="chart-wrapper">
          <canvas id="outgoingDonutChart" aria-label="Outgoing transfer processes chart"></canvas>
        </div>

        <div class="legend">
          <span class="legend-item"><span class="dot completed"></span>Completed</span>
          <span class="legend-item"><span class="dot progress"></span>In Progress</span>
          <span class="legend-item"><span class="dot error"></span>Error</span>
        </div>

        <p class="total">Total: {{ outgoingTotal }}</p>
      </div>

      <ng-template #noOutgoingData>
        <div class="no-data-placeholder">No data</div>
      </ng-template>
    </mat-card>

    <mat-card class="panel connector-panel">
      <div class="connector-header">
        <h2>EDC Connector</h2>
        <p class="panel-subtitle">{{getConfigValue('participantId') || 'My Connector'}}<span class="version-pill">{{ getConfigValue('edcVersion') || '-' }}</span></p>
      </div>

      <p class="connector-description">{{ getConfigValue('description') || '-' }}</p>
      <p class="helper-text">
        Share the following Connector Endpoint to let others access your EDC Connector's catalog.
      </p>

      <div class="copy-field-group">
        <label>Catalog URL</label>
        <div class="copy-field">
          <input
            class="readonly-field"
            type="text"
            value="{{ getConfigValue('connectorEndpoint') || '-' }}"
            readonly
            (focus)="selectReadonlyField($event)">
          <button
            type="button"
            aria-label="Copy endpoint and participant id"
            (click)="copyToClipboard(getConfigValue('connectorEndpoint') || '')">
            <span class="material-icons">content_copy</span>
          </button>
        </div>
      </div>

      <div class="copy-field-group">
        <label>Management API URL</label>
        <div class="copy-field">
          <input
            class="readonly-field"
            type="text"
            [value]="managementApiUrl || '-'"
            readonly
            (focus)="selectReadonlyField($event)">
          <button
            type="button"
            aria-label="Copy management api url"
            (click)="copyToClipboard(managementApiUrl)">
            <span class="material-icons">content_copy</span>
          </button>
        </div>
      </div>
    </mat-card>
  </section>

  <section class="kpi-grid">
    <mat-card class="kpi-card">
      <p class="kpi-value">{{ dataOffersCount }}</p>
      <p class="kpi-label">Your Data Offers</p>
    </mat-card>

    <mat-card class="kpi-card">
      <p class="kpi-value">{{ assetsCount }}</p>
      <p class="kpi-label">Your Assets</p>
    </mat-card>

    <mat-card class="kpi-card">
      <p class="kpi-value">{{ policiesCount }}</p>
      <p class="kpi-label">Your Policies</p>
    </mat-card>

    <mat-card class="kpi-card">
      <p class="kpi-value">{{ negotiationsCount }}</p>
      <p class="kpi-label">Contract Negotiations</p>
    </mat-card>

    <mat-card class="kpi-card">
      <p class="kpi-value">{{ contractAgreementsCount }}</p>
      <p class="kpi-label">Contract Agreements</p>
    </mat-card>
  </section>

  <mat-card class="panel properties-panel">
    <h2>Connector Properties</h2>
    <p class="panel-subtitle">Additional Properties</p>

    <div class="properties-grid">
      <div class="property-item">
        <span class="material-icons">title</span>
        <div>
          <p class="property-label">Title</p>
          <p class="property-value">{{ getConfigValue('title') || '-' }}</p>
        </div>
      </div>

      <div class="property-item">
        <span class="material-icons">description</span>
        <div>
          <p class="property-label">Description</p>
          <p class="property-value property-value-config">{{ getConfigValue('description') || '-' }}</p>
        </div>
      </div>

      <div class="property-item">
        <span class="material-icons">rocket_launch</span>
        <div>
          <p class="property-label">Version</p>
          <p class="property-value">{{ getConfigValue('edcVersion') || '-' }}</p>
        </div>
      </div>

      <div class="property-item">
        <span class="material-icons">badge</span>
        <div>
          <p class="property-label">Participant ID</p>
          <div class="copy-field">
            <input
              class="readonly-field"
              type="text"
              [value]="getConfigValue('participantId') || '-'"
              readonly
              (focus)="selectReadonlyField($event)">
            <button
              type="button"
              aria-label="Copy participant id"
              (click)="copyToClipboard(getConfigValue('participantId'))">
              <span class="material-icons">content_copy</span>
            </button>
          </div>
        </div>
      </div>

      <div class="property-item">
        <span class="material-icons">link</span>
        <div>
          <p class="property-label">Connector Endpoint</p>
          <div class="copy-field">
            <input
              class="readonly-field"
              type="text"
              [value]="getConfigValue('connectorEndpoint') || '-'"
              readonly
              (focus)="selectReadonlyField($event)">
            <button
              type="button"
              aria-label="Copy connector endpoint"
              (click)="copyToClipboard('https://edc.fake-backend/api/dsp')">
              <span class="material-icons">content_copy</span>
            </button>
          </div>
        </div>
      </div>

      <div class="property-item">
        <span class="material-icons">apartment</span>
        <div>
          <p class="property-label">Curator Organization Name</p>
          <p class="property-value">{{ getConfigValue('curatorOrganizationName') || '-' }}</p>
        </div>
      </div>

      <div class="property-item">
        <span class="material-icons">home</span>
        <div>
          <p class="property-label">Curator URL</p>
          <a
            href="{{ getConfigValue('curatorUrl') || '#' }}"
            target="_blank"
            rel="noreferrer"
            [attr.title]="getConfigValue('curatorUrl') || '-'">{{ getConfigValue('curatorUrl') || '-' }}</a>
        </div>
      </div>

      <!-- <div class="property-item" *ngFor="let variable of configVariables">
        <span class="material-icons">tune</span>
        <div>
          <p class="property-label">{{ variable.label }}</p>
          <p class="property-value property-value-config">{{ variable.value }}</p>
        </div>
      </div> -->

      <div class="property-item">
        <span class="material-icons">corporate_fare</span>
        <div>
          <p class="property-label">Maintainer Organization Name</p>
          <p class="property-value">{{ getConfigValue('maintainerOrganizationName') || '-' }}</p>
        </div>
      </div>

      <div class="property-item">
        <span class="material-icons">home_work</span>
        <div>
          <p class="property-label">Maintainer URL</p>
          <a
            href="{{ getConfigValue('maintainerUrl') || '#' }}"
            target="_blank"
            rel="noreferrer"
            [attr.title]="getConfigValue('maintainerUrl') || '-'">{{ getConfigValue('maintainerUrl') || '-' }}</a>
        </div>
      </div>
    </div>
  </mat-card>
</div>
